import { useDispatch, useSelector } from "react-redux";
import {
  addInstitution,
  deleteInstitution,
  getInstitution,
  updateInstitution,
  setRedirection,
  setActiveInstitutions,
  setOffset,
  setPage,
  setPerPage,
} from "../store/institution";

export default function useInstitution() {
  const dispatch = useDispatch();

  const institutionData = useSelector(
    (state) => state.institution.newInstitutionList
  );
  const loading = useSelector((state) => state.institution.loading);

  const activeInstitution = useSelector(
    (state) => state.institution.activeInstitutions
  );
  const redirect = useSelector((state) => state.institution.redirect);

  const page = useSelector((state) => state.institution?.page);
  const perPage = useSelector((state) => state.institution?.perPage);
  const offset = useSelector((state) => state.institution?.offset);
 

  const setOffsetAction = (params) => dispatch(setOffset(params));
  const setPerPageAction = (params) => dispatch(setPerPage(params));
  const setPageAction = (params) => dispatch(setPage(params));

  const getInstitutionAction = (params) => dispatch(getInstitution(params));
  const updateInstitutionAction = (params) =>
    dispatch(updateInstitution(params));
  const deleteInstitutionAction = (params) =>
    dispatch(deleteInstitution(params));
  const addInstitutionAction = (params) => dispatch(addInstitution(params));

  const setActiveInstitutionAction = (params) =>
    dispatch(setActiveInstitutions(params));
  const setRedirectAction = (params) => dispatch(setRedirection(params));

  return {
    institutionData,
    loading,

    activeInstitution,
    redirect,
    page,
    perPage,
    offset,

    // actions
    setOffsetAction,
    setPerPageAction,
    setPageAction,
    getInstitutionAction,
    updateInstitutionAction,
    deleteInstitutionAction,
    addInstitutionAction,
    setActiveInstitutionAction,
    setRedirectAction,
  };
}
